import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import "./contact.css";
import Loading from "../../Components/Loading/Loading";

function Contact() {
  const [contactInfo, setContactInfo] = useState();
  const [loading, setLoading] = useState(true);
  const isFetched = useRef(false); // ✅ Prevents duplicate API call
  useEffect(() => {
    if (!isFetched.current) {
      getContactInfo();
      isFetched.current = true; // ✅ Ensure it runs only once
    }
  }, []);

  const getContactInfo = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "api/Contacts"
      );

      if (response.data) {
        setContactInfo(response.data);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching contact infos:", error);
    }
  };

  if (loading) return <Loading />;
  return (
    <div className="contact-container">
      <div className="contactdesktop-version">
        <div className="contact-title">
          <div className="title-container">
            <div className="temp">
              <h1>DON’T</h1>
              <h2>HESITATE TO</h2>
              <h3>REACH OUT</h3>
            </div>
          </div>
        </div>
        <div className="contact-info">
          <a className="email-contact" href={`mailto:${contactInfo.email}`}>
            {contactInfo.email}
          </a>
          <a
            className="number-contact"
            href={`https://wa.me/${contactInfo.phoneNumber.replace(
              /[^0-9]/g,
              ""
            )}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {contactInfo.phoneNumber}
          </a>
        </div>
      </div>
      <div className="contactmobile-version">
        <div className="mobilecontact-title">
          <p className="contactfirstmobile-title">DON’T</p>
          <p className="contactsecondmobile-title">HESITATE</p>
          <p className="contactthirmobile-title">TO</p>
          <p className="contactfourthmobiletitle">REACH OUT</p>
        </div>
        <div className="mobilecontactinfo">
          <a className="email-contact" href={`mailto:${contactInfo.email}`}>
            {contactInfo.email}
          </a>
          <a
            className="number-contact"
            href={`https://wa.me/${contactInfo.phoneNumber.replace(
              /[^0-9]/g,
              ""
            )}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {contactInfo.phoneNumber}
          </a>
        </div>
      </div>
    </div>
  );
}

export default Contact;
